module IS.Localization {

    angular.module('localization').filter('i18n', ['localizeService', function (localizeService: LocalizeService) {
        return function (input: string) {
            return localizeService.getLocalizedResource(input);
        };
    }]);

}